import {
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Award,
  Bell,
  BellRing,
  BookOpen,
  BookOpenCheck,
  Building2,
  CalendarCheck2,
  ChartColumnIncreasing,
  ChartNoAxesCombined,
  CheckCircle2,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleAlert,
  CircleHelp,
  CirclePlay,
  ClipboardCheck,
  ClipboardList,
  CloudOff,
  Download,
  ExternalLink,
  Eye,
  EyeOff,
  File,
  FilePlus2,
  FileText,
  Fingerprint,
  Flag,
  FolderOpen,
  FolderPlus,
  GraduationCap,
  History,
  Image,
  Layers,
  KeyRound,
  LayoutDashboard,
  LibraryBig,
  LockKeyhole,
  LockKeyholeOpen,
  LogOut,
  Mail,
  Menu,
  MessageCircle,
  Music2,
  PencilLine,
  Plus,
  RefreshCw,
  Save,
  Search,
  Send,
  ShieldCheck,
  Timer,
  Trash2,
  TriangleAlert,
  Upload,
  UserRound,
  UsersRound,
  X,
  Ban,
  Clock3,
  type LucideIcon,
  type LucideProps,
} from "lucide-react";
import { cn } from "@/lib/utils";

// Nombres compartidos por navegación, tarjetas y estados de la aplicación.
export const icons = {
  access_time: Clock3,
  account_circle: UserRound,
  add: Plus,
  arrow_back: ArrowLeft,
  arrow_downward: ArrowDown,
  arrow_forward: ArrowRight,
  arrow_upward: ArrowUp,
  assessment: ChartNoAxesCombined,
  assignment: ClipboardList,
  assignment_turned_in: ClipboardCheck,
  audiotrack: Music2,
  block: Ban,
  business: Building2,
  card_membership: Award,
  chat: MessageCircle,
  check_circle: CheckCircle2,
  chevron_left: ChevronLeft,
  chevron_right: ChevronRight,
  close: X,
  cloud_off: CloudOff,
  cloud_upload: Upload,
  create_new_folder: FolderPlus,
  dashboard: LayoutDashboard,
  delete_outline: Trash2,
  description: FileText,
  edit: PencilLine,
  error: CircleAlert,
  error_outline: CircleAlert,
  event_available: CalendarCheck2,
  exit_to_app: LogOut,
  expand_less: ChevronUp,
  expand_more: ChevronDown,
  fingerprint: Fingerprint,
  flag: Flag,
  folder_shared: FolderOpen,
  get_app: Download,
  help_outline: CircleHelp,
  history: History,
  image: Image,
  insert_chart: ChartColumnIncreasing,
  insert_drive_file: File,
  keyboard_arrow_left: ChevronLeft,
  keyboard_arrow_right: ChevronRight,
  keyboard_backspace: ArrowLeft,
  layers: Layers,
  local_library: LibraryBig,
  lock: LockKeyhole,
  lock_open: LockKeyholeOpen,
  mail_outline: Mail,
  menu_book: BookOpen,
  note_add: FilePlus2,
  notifications_active: BellRing,
  notifications_none: Bell,
  open_in_new: ExternalLink,
  people: UsersRound,
  play_circle_outline: CirclePlay,
  refresh: RefreshCw,
  save: Save,
  schedule: Clock3,
  school: GraduationCap,
  search: Search,
  send: Send,
  short_text: Menu,
  timer: Timer,
  verified_user: ShieldCheck,
  visibility: Eye,
  visibility_off: EyeOff,
  warning: TriangleAlert,
  vpn_key: KeyRound,
  learning: BookOpenCheck,
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof icons;

export function Icon({
  name,
  className,
  ...props
}: LucideProps & { name: string }) {
  const Component = (icons as Record<string, LucideIcon>)[name] ?? CircleHelp;
  return (
    <Component
      strokeWidth={1.8}
      aria-hidden="true"
      focusable="false"
      {...props}
      className={cn("scp-icon", className)}
      data-icon={name}
      data-icon-unknown={name in icons ? undefined : "true"}
    />
  );
}
